
(function (document, window, $) {
    'use strict';
    var CommonModule = {
        data: {
            urls: {
                base: null,
                current: null,
            },
            query: null,
        },

        //--------------------------------------------------------------------------
        init: function () {
            this.data.urls.current = window.location.href;
        },
        //--------------------------------------------------------------------------
        topMenu: function(element)
        {
            $(".navbar-burger").click(function() {

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                $(".navbar-burger").toggleClass("is-active");
                $(".navbar-menu").toggleClass("is-active");

            });
        },
        //--------------------------------------------------------------------------

        //--------------------------------------------------------------------------
        run: function () {
            this.init();
            this.topMenu();

        },
        //--------------------------------------------------------------------------


    };
//-------------------------------------------
    $(document).ready(function () {
        CommonModule.run();
    });
//-------------------------------------------


//-------------------------------------------
})(document, window, jQuery);
//-------------------------------------------

